import { MouseEvent } from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from '@material-ui/core';

// Opens the extension form, which creates a successor order (change request
// of 06.10: "Extend" instead of "Renew"; the behaviour is unchanged).
const ExtendOrderButton = ({
  orderNumber,
  variant = 'contained',
}: {
  orderNumber: string;
  variant?: ButtonProps['variant'];
}) => {
  const intl = useIntl();
  return (
    <Button
      component={Link}
      to={`/assignments/${encodeURIComponent(orderNumber)}/extend`}
      color="primary"
      variant={variant}
      size="small"
      onClick={(event: MouseEvent) => event.stopPropagation()}
    >
      {intl.formatMessage({ id: 'ORDERS.RENEW' })}
    </Button>
  );
};

export default ExtendOrderButton;
